var _defs, _g, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _path4, _polygon5, _polygon6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnRoomLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.23 198.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ea8b77;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#515353;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1436.96,
    y1: 15.62,
    x2: 1470.96,
    y2: 15.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 1474.99, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1163.13,
    y1: 94.49,
    x2: 1461.58,
    y2: 94.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5214.95,
    y1: -2606,
    x2: -5180.95,
    y2: -2606,
    gradientTransform: "matrix(1, 0, 0, -1, 5503.19, -2433.2)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.67 11.04 28.82 23.17 38.1 17.53 37.95 5.39 28.67 11.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.03 5.39 4.03 5.74 4.14 25.84 16.16 18.59 26 12.65 38.03 5.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.14 25.84 4.1 37.97 13.56 32.33 13.41 20.2 4.14 25.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "28.64 11.04 13.41 20.2 296.62 177.95 311.86 168.79 28.64 11.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.41 20.2 13.56 32.33 296.09 190.09 296.62 177.95 13.41 20.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "288.24 183.03 288.24 195.45 322.39 194.82 322.24 182.68 288.24 183.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "288.24 183.03 322.24 182.68 322.13 162.58 310.1 169.83 300.26 175.77 288.24 183.03"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114,38.71l2.94,8.12V47l-3-1.74L111.36,38l-2.24-1.3v5.75l-2.82-1.63,0-15.69,5.08,2.93a10.89,10.89,0,0,1,3.73,3.39,7.61,7.61,0,0,1,1.3,4.26,3.63,3.63,0,0,1-.61,2.33A2.1,2.1,0,0,1,114,38.71Zm-.95-3c.39-.19.58-.65.58-1.37a3.9,3.9,0,0,0-.54-2.06,4.28,4.28,0,0,0-1.68-1.61l-2.26-1.31V34.1l2.27,1.31c.71.41,1.25.52,1.64.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.07,41.72a13.92,13.92,0,0,1,.72,4.48v.7a7.88,7.88,0,0,1-.73,3.66,2.67,2.67,0,0,1-2,1.51,4.89,4.89,0,0,1-3-.81,10.5,10.5,0,0,1-3-2.69,12.94,12.94,0,0,1-2.06-3.87,13.92,13.92,0,0,1-.72-4.42V39.5a7.63,7.63,0,0,1,.74-3.66A2.71,2.71,0,0,1,121,34.32a5,5,0,0,1,3,.81,10.52,10.52,0,0,1,3,2.69A12.93,12.93,0,0,1,129.07,41.72Zm-2.14,3.59v-.76a10.34,10.34,0,0,0-.76-4.2A5.33,5.33,0,0,0,124,37.8c-.95-.54-1.68-.55-2.19,0a5,5,0,0,0-.79,3.27v.77a10.46,10.46,0,0,0,.75,4.17,5.36,5.36,0,0,0,2.22,2.6c.94.55,1.66.54,2.18,0a5.19,5.19,0,0,0,.77-3.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.33,49.37a13.71,13.71,0,0,1,.72,4.49v.7a7.87,7.87,0,0,1-.73,3.65,2.66,2.66,0,0,1-2,1.52,4.89,4.89,0,0,1-3.05-.81,10.48,10.48,0,0,1-3-2.69,12.83,12.83,0,0,1-2.06-3.87,13.67,13.67,0,0,1-.73-4.43v-.77a7.63,7.63,0,0,1,.74-3.66A2.66,2.66,0,0,1,134.22,42a4.82,4.82,0,0,1,3,.81,10.37,10.37,0,0,1,3,2.69A13,13,0,0,1,142.33,49.37ZM140.19,53V52.2a10.32,10.32,0,0,0-.76-4.19,5.33,5.33,0,0,0-2.19-2.55q-1.42-.83-2.19,0c-.52.55-.78,1.64-.79,3.26v.77a10.42,10.42,0,0,0,.76,4.17,5.32,5.32,0,0,0,2.21,2.61c.94.54,1.67.54,2.18,0a5.14,5.14,0,0,0,.77-3.29"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "159.48 55.83 159.44 71.53 156.61 69.89 156.63 65.6 156.93 58.36 153.21 67.93 151.28 66.81 147.64 53.01 147.9 60.56 147.89 64.86 145.07 63.23 145.12 47.54 148.79 49.66 152.27 63.06 155.79 53.7 159.48 55.83"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "169.54 61.64 169.5 74.73 175.48 78.18 175.47 80.78 166.68 75.7 166.72 60.01 169.54 61.64"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "186.26 71.29 186.25 73.91 179.93 70.26 179.92 74 185.32 77.12 185.31 79.63 179.91 76.51 179.9 80.74 186.24 84.4 186.23 87 177.08 81.71 177.13 66.02 186.26 71.29"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.03 78.67 198.99 94.36 196.17 92.73 190.72 79.24 190.7 89.57 187.89 87.95 187.93 72.26 190.74 73.88 196.2 87.39 196.23 77.05 199.03 78.67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.87,83a10.87,10.87,0,0,1,3.8,3.52,10.5,10.5,0,0,1,1.61,4.81l-2.74-1.58a5.91,5.91,0,0,0-.82-2.45A5.12,5.12,0,0,0,207,85.63c-1-.55-1.69-.56-2.19,0a5,5,0,0,0-.77,3.25v1a9.83,9.83,0,0,0,.81,4.2,5.73,5.73,0,0,0,2.38,2.64c1.06.61,1.82.79,2.26.53v-2.7l-2.56-1.48V90.67l5.37,3.1V100a2.68,2.68,0,0,1-2.15.38,9,9,0,0,1-3.08-1.2,11,11,0,0,1-3.11-2.68,12.28,12.28,0,0,1-2-3.77,13.61,13.61,0,0,1-.74-4.41V87.29a8.19,8.19,0,0,1,.7-3.68,2.57,2.57,0,0,1,2-1.48A5.07,5.07,0,0,1,206.87,83Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "224.85 93.58 224.85 96.19 220.66 93.78 220.63 106.85 217.81 105.23 217.85 92.15 213.72 89.77 213.73 87.15 224.85 93.58"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "237.57 100.92 237.53 116.61 234.71 114.98 234.73 108.26 229.25 105.09 229.23 111.82 226.41 110.19 226.46 94.5 229.27 96.13 229.25 102.49 234.74 105.65 234.76 99.29 237.57 100.92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnRoomLength);
export default __webpack_public_path__ + "static/media/en-room-length.671d8c84f1be79434c7c76f2282fed3f.svg";
export { ForwardRef as ReactComponent };